import { orchestrator } from 'satcheljs';
import { accountConnected } from 'owa-accounts-service';
import addMergedViewAvailabilityAccount from '../utils/addMergedViewAvailabilityAccount';
import { updatingTrueTimeStore } from '../actions/publicActions';
import { getMergeViewEnabledAccount } from '../selectors/getMergeViewEnabledAccount';

orchestrator(accountConnected, async ({ primarySmtpAddress }) => {
    if (!getMergeViewEnabledAccount()) {
        // Turning on true time by default, show the spinner
        updatingTrueTimeStore(primarySmtpAddress);

        // Turning on true time
        await addMergedViewAvailabilityAccount(primarySmtpAddress);

        // True time is turned on, so hiding the spinner
        updatingTrueTimeStore(null);
    }
});
